import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import AnchorLink from 'react-anchor-link-smooth-scroll'

import Header from 'App/Header'
import HeaderMeuNegocio from 'HomePageItauMeuBairro/Header'
import { FooterContainer } from 'App/Footer'
import FooterMeuNegocio from 'HomePageItauMeuBairro/Footer'
import FingerPrintContainer from 'App/FingerPrint/FingerPrintContainer'
import Widgets from 'Widgets'
// import MediaQuery from 'react-responsive'

import { useLastLocation } from 'react-router-last-location'

const Shell = ({ children, profile }) => {
  const [ headBairro, useHeadBairro ] = useState(false)

  useEffect(() => {
    if (children.props.children.props.path === '/meu-negocio') {
      useHeadBairro(true)
    }

    // Removendo outline no clique do mouse
    var htmlElement = document.querySelector('html')
    htmlElement.classList.add('clicking')

    document.addEventListener('click', function () {
      htmlElement.classList.add('clicking')
    })

    document.addEventListener('keyup', function (e) {
      if (e.keyCode === 9) {
        htmlElement.classList.remove('clicking')
      }
    })

    // Menu de acessibilidade
    const accessibilityMenus = document.getElementById('accessibility-menu-anchors')

    if (accessibilityMenus !== null) {
      accessibilityMenus.setAttribute('tabindex', '0')
      accessibilityMenus.focus()
      accessibilityMenus.addEventListener('blur', function () {
        accessibilityMenus.removeAttribute('tabindex')
      })
      accessibilityMenus.blur()
    } else {
      const btnBackPage = document.querySelector(`.btn-back-page`)

      btnBackPage && btnBackPage.focus()
    }
  })

  const refererIsLogin = () => (
    (typeof useLastLocation() !== 'undefined' && useLastLocation()) && (useLastLocation().pathname.toString().indexOf('auth') > -1)
  )

  // const handleFocus = (target) => {
  //   document.activeElement.blur()

  //   setTimeout(() => {
  //     let targetElement = document.querySelector(`${target}`)

  //     if (target === '#mainContainer') {
  //       targetElement = document.querySelector('h1')
  //     }

  //     if (targetElement) {
  //       targetElement.setAttribute('tabindex', '0')
  //       targetElement.focus()
  //       targetElement.addEventListener('blur', function () {
  //         targetElement.removeAttribute('tabindex')
  //       })
  //     }
  //   }, 300)
  // }

  return (
    <div className='bg-ui-4' data-campaign={process.env.REACT_APP_CATALOG_ID}>
      { refererIsLogin() && <FingerPrintContainer /> }
      {/* { !headBairro && (
        <MediaQuery minDeviceWidth={1025}>
          <div className='accessibility-menu' id='accessibility-menu-anchors'>
            <AnchorLink
              href='#header'
              data-target='#header'
              className='flex-item mn-item mn-experiences'
              onClick={() => handleFocus('#header')}
            >
            Ir para o menu
            </AnchorLink>
            <AnchorLink
              href='#mainContainer'
              data-target='#mainContainer'
              className='flex-item mn-item mn-experiences'
              onClick={() => handleFocus('#mainContainer')}
            >
            Ir para o conteúdo principal
            </AnchorLink>
            <AnchorLink
              href='#footer'
              data-target='#footer'
              className='flex-item mn-item mn-experiences'
              onClick={() => handleFocus('#footer')}
            >
            Ir para o rodapé
            </AnchorLink>
          </div>
        </MediaQuery>
      ) } */}
      { headBairro ? <HeaderMeuNegocio profile={profile} /> : <Header refererIsLogin={refererIsLogin()} />}
      <div id='mainContainer' className='container-fluid px-0 py-0' role='main'>
        {children}
      </div>
      { headBairro ? <FooterMeuNegocio /> : <FooterContainer /> }
      {profile && <Widgets />}
    </div>
  )
}

Shell.propTypes = {
  children: PropTypes.node,
  profile: PropTypes.object
}

export default Shell



// WEBPACK FOOTER //
// ./src/App/Shell/Shell.js